import React from 'react'

interface StratIQXHeaderProps {
  subtitle?: string;
  title: string;
  description?: string;
  compact?: boolean;
}

export const StratIQXHeader: React.FC<StratIQXHeaderProps> = ({
  subtitle,
  title,
  description,
  compact = false
}) => {
  return (
    <div className={`text-center ${compact ? 'mb-4' : 'mb-8'}`}>
      <div className={`${compact ? 'mb-2' : 'mb-4'}`}>
        <h1 className="text-4xl font-bold text-gray-900 mb-2">
          Strat<span className="text-blue-600">IQ</span><span className="text-cyan-600">X</span>
        </h1>
        {subtitle && (
          <div className="text-lg text-gray-600 font-medium">
            {subtitle}
          </div>
        )}
      </div>
      <h2 className={`text-3xl font-bold text-gray-900 ${description ? 'mb-2' : ''}`}>
        {title}
      </h2>
      {description && (
        <p className="text-lg text-gray-600">
          {description}
        </p>
      )}
    </div>
  );
};